import { makeStyles } from '@mui/styles';
import * as colors from 'apollo-react/colors';
import IconButton from 'apollo-react/components/IconButton';
import Peek from 'apollo-react/components/Peek';
import Info from 'apollo-react-icons/Info';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import * as constants from './constants';
import TaskStatusCardInfoContent from './TaskStatusCardInfoContent';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getIsRtlLanguage } from '../../selectors/AuthSelectors';

const useStyles = makeStyles({
  infoButtonContainer: {
    position: 'absolute',
    right: 5,
    top: 0,
  },
  infoButtonContainerRtl: {
    float: 'left',
    marginTop: -17,
    marginLeft: -10,
  },
  infoButtonRoot: {
    padding: 0,
    width: 'auto',
    height: 'auto',
    color: colors.neutral5,
    '&$hover': {
      color: colors.neutral5,
      backgroundColor: 'unset',
    },
  },
  infoIcon: {
    fontSize: 16,
  },
  hover: {},
});

const TaskStatusCardInfo = ({
  isInitialTask,
  isTaskPortal,
  status,
  label,
  date,
  user,
  remainingDays,
  overdueDays,
}) => {
  const translateString = useTranslation();
  const isRtlLanguage = useSelector(getIsRtlLanguage);
  const classes = useStyles();

  return (
    <Peek
      className={isRtlLanguage ? classes.infoButtonContainerRtl : classes.infoButtonContainer}
      placement="right"
      anchor={
        <IconButton
          aria-label={translateString('See Task Info')}
          className={classNames(classes.infoButtonRoot, classes.hover)}
          disableRipple
        >
          <Info
            className={classes.infoIcon}
            color={status === constants.taskStatuses.ACTIVE ? 'primary' : 'inherit'}
          />
        </IconButton>
      }
      content={
        <TaskStatusCardInfoContent
          isInitialTask={isInitialTask}
          isTaskPortal={isTaskPortal}
          status={status}
          label={label}
          date={date}
          user={user}
          remainingDays={remainingDays}
          overdueDays={overdueDays}
        />
      }
    />
  );
};

export default TaskStatusCardInfo;
